import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import AutoComplete from 'material-ui/AutoComplete';
import { List, ListItem } from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import IconClear from 'material-ui/svg-icons/content/clear';
import IconAdd from 'material-ui/svg-icons/content/add';
import buttonStyle from './ui/button';
import { formElement } from '../lib/styles';
import listStyle from './ui/list-style';
import './ui/topic-selector.css';

class TopicSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = this._stateForProps(this.props);
    }

    componentWillReceiveProps(newProps, nextContext) {
        this.setState(this._stateForProps(newProps));
    }

    _stateForProps = (props) => {
        const existingIds = props.value.map(v => v.id);
        return {
            searchText: '',
            value: props.value,
            topics: props.viewer.topicsForSelector.edges
                .map(edge => edge.node)
                .filter(t => (existingIds.indexOf(t.id) === -1)),
        }
    };

    removeTopic = (id) => {
        if (this.props.onChange) {
            this.props.onChange(this.state.value.filter(v => v.id !== id));
        }
    };

    _onNewTopic = (text, index) => {
        if (index === -1) {
            // это enter в поле
            const topics = this.state.topics.filter(topic => (topic.name === text));
            if (topics.length > 0) {
                const topic = topics[0];
                if (this.props.onChange) {
                    const res = [].concat(this.state.value, topic);
                    const resString = JSON.stringify(res);
                    console.log(`will set topics: ${resString}`);
                    this.props.onChange(res)
                }
            }
        } else {
            const suggestions = this.state.topics.slice(0);
            const topic = suggestions.splice(index, 1);
            if (this.props.onChange) {
                const res = [].concat(this.state.value, topic);
                this.props.onChange(res)
            }
        }
    };

    renderAutoCompleteSimple = () => (
        <AutoComplete
            hintText="+"
            hintStyle={{
                color: '#757575',
                fontSize: 25,
                bottom: 9,
                left: 4,
            }}
            openOnFocus={true}
            fullWidth={true}
            dataSourceConfig={{ text: 'name', value: 'id' }}
            filter={AutoComplete.fuzzyFilter}
            dataSource={this.state.topics}
            searchText={this.state.searchText}
            onUpdateInput={(s, d) => this.setState({ searchText: s })}
            onNewRequest={this._onNewTopic.bind(this)}
            menuStyle={{ maxHeight: '30vh', overflowY: 'auto' }}
        />
    );

    renderList = (removeTopic) => {
        return (
            <div>
                <List style={{ marginTop: -13 }}>
                    {
                        this.state.value.map((t, index) =>
                            <span key={index}>
                                <ListItem
                                    innerDivStyle={listStyle.item}
                                    key={t.id}
                                    primaryText={t.name}
                                    rightIconButton={
                                        <IconButton
                                            style={buttonStyle.smallIcon}
                                            onClick={() => removeTopic(t.id)}
                                        >
                                            <IconClear color="#777" hoverColor="#542376"/>
                                        </IconButton>
                                    }
                                />
                                <Divider style={formElement.divider}/>
                            </span>
                        )
                    }
                </List>
                {this.renderAutoCompleteSimple()}
            </div>
        );
    };

    renderAutoCompleteCloud = (lineId) => {
        const id = (new Date()).getTime().toString();
        return (
            <div style={{ display: 'flex', flexGrow: '1', marginTop: 14 }}>
                <IconAdd color='#777' style={{ marginTop: -9, marginRight: -20 }} id={id}/>
                <AutoComplete
                    hintText="+"
                    hintStyle={{
                        fontSize: 0
                    }}
                    openOnFocus={true}
                    fullWidth={true}
                    dataSourceConfig={{ text: 'name', value: 'id', }}
                    filter={AutoComplete.fuzzyFilter}
                    dataSource={this.state.topics}
                    searchText={this.state.searchText}
                    onUpdateInput={(s, d) => this.setState({ searchText: s })}
                    onNewRequest={this._onNewTopic.bind(this)}
                    onClose={() => {
                        const icon = document.getElementById(id);
                        const lineWrapper = document.getElementById(lineId);
                        lineWrapper.getElementsByTagName('small')[0].style.color = '#767676';
                        icon.style.display = 'block';
                        lineWrapper.classList.remove('is_active');
                        this.setState({ searchText: '' });
                    }}
                    menuStyle={{
                        maxHeight: "30vh",
                        top: 50
                    }}
                    underlineShow={false}
                    textFieldStyle={{
                        height: '38px',
                        marginTop: -5
                    }}
                    popoverProps={{
                        style: {
                            maxWidth: 250,
                            width: 250
                        }
                    }}

                    inputStyle={{
                        fontSize: 14,
                        bottom: 11,
                        paddingLeft: 14
                    }}
                    style={{ marginBottom: -5 }}
                    onClick={() => {
                        const icon = document.getElementById(id);
                        const lineWrapper = document.getElementById(lineId);
                        lineWrapper.getElementsByTagName('small')[0].style.color = '#542376';
                        lineWrapper.classList.add('is_active');
                        icon.style.display = 'none';
                    }}
                />
            </div>
        );
    };

    renderCloud = (removeTopic, underline) => {
        return (
            <div className='topic-selector--wrapper'>
                {this.state.value.map((t, index) =>
                    <div
                        key={index}
                        className='topic-selector--item topic-selector--item__cloud'
                        onClick={ () => { removeTopic(t.id) } }
                    >
                        {t.name}
                        <div className='topic-selector--item-button'>
                            <IconClear
                                color='#777'
                                hoverColor='#542376'
                                className='topic-selector--item-icon'
                            />
                        </div>
                    </div>
                )}
                {this.renderAutoCompleteCloud(underline)}
            </div>
        )
    };

    render() {
        const removeTopic = this.removeTopic.bind(this);
        const title = this.props.title || 'Темы';
        return (
            <div style={{ width: '100%' }}>
                <small style={formElement.small}>{title}</small>
                {
                    this.props.type === 'cloud' ?
                        this.renderCloud(removeTopic, this.props.underline) :
                        this.renderList(removeTopic)
                }
            </div>
        )
    }

}

export default createFragmentContainer(
    TopicSelector,
    graphql`
        fragment TopicSelector_viewer on Viewer {
            topicsForSelector: topics(first: -1) {
                edges {
                    node {
                        id,
                        name
                    }
                }
            }
        }
    `
)



// WEBPACK FOOTER //
// src/components/TopicSelector.js